import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { Table, Tag } from "antd";
import { fmtFechaDia } from "../../../Components/Items";

// Color de la etiqueta de estatus de una asignacion (tablero, detalle e historial).
export const COLOR_ESTATUS = {
  "En proceso": "blue",
  Pausado: "orange",
  Terminado: "green",
  Entregado: "cyan",
  Reasignada: "default",
  Cancelada: "red",
};

// Quien trabajo la pieza, en que etapa y cuando (AsignacionAgrupacion). Se usa en el detalle
// del tablero por persona y en Ver Agrupacion. `recargar` fuerza una nueva consulta.
class HistorialTrabajo extends Component {
  state = { loading: false, asignaciones: [] };

  componentDidMount() {
    this.consultar();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.agrupacionId !== this.props.agrupacionId || prevProps.recargar !== this.props.recargar) {
      this.consultar();
    }
  }

  consultar = () => {
    if (!this.props.agrupacionId) {
      this.setState({ asignaciones: [] });
      return;
    }
    this.setState({ loading: true });
    axios
      .post(
        "asignacionesAgrupacion/selectAsignacionesAgrupacion",
        { empresaId: this.props.empresaId, agrupacionId: this.props.agrupacionId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false, asignaciones: res.data.success === 2 ? res.data.asignaciones : [] });
      })
      .catch(() => this.setState({ loading: false, asignaciones: [] }));
  };

  render() {
    const columnas = [
      { title: "Etapa", dataIndex: "etapaNombre", key: "etapaNombre" },
      { title: "Persona", dataIndex: "empleadoNombre", key: "empleadoNombre" },
      { title: "Inicio", dataIndex: "fechaInicio", key: "fechaInicio", render: (f) => fmtFechaDia(f) },
      { title: "Término", dataIndex: "fechaTermino", key: "fechaTermino", render: (f) => fmtFechaDia(f) },
      { title: "Días háb.", dataIndex: "diasHabiles", key: "diasHabiles", align: "right" },
      {
        title: "Estatus",
        dataIndex: "estatusTexto",
        key: "estatusTexto",
        render: (e) => <Tag color={COLOR_ESTATUS[e] || "default"}>{e}</Tag>,
      },
      { title: "Notas", dataIndex: "notas", key: "notas" },
    ];

    if (!this.state.loading && this.state.asignaciones.length === 0 && this.props.ocultarVacio) return null;

    return (
      <div style={{ marginTop: 12 }}>
        <div style={{ fontWeight: "bold", marginBottom: 6 }}>Historial de trabajo</div>
        <Table
          size="small"
          rowKey="_id"
          loading={this.state.loading}
          columns={columnas}
          dataSource={this.state.asignaciones}
          pagination={false}
          locale={{ emptyText: "Sin asignaciones registradas" }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(HistorialTrabajo);
